// The lines AddressBlock (AddressBlock.jsx) shows and copies: name, street,
// city-region-zip, and the country on its own line when the order carries
// one (2026-10-07). Never defaulted: no country, no line.
export function addressLines({ name, address1, address2, city, region, postalCode, country }) {
  return [
    name,
    [address1, address2].filter(Boolean).join(' '),
    [city, region, postalCode].filter(Boolean).join(', '),
    country,
  ].filter(Boolean)
}
